export default "__VITE_ASSET__BWU76Rv___"